import {
  ICreateUserRequest,
  IDeleteUserRequest,
  IGetAdminUsersRequest,
  IResetPasswordRequest,
  ISetTemporaryPasswordRequest,
  IToggleEnabledRequest,
  IUpdateUserRequest,
} from '../../types/api/request/adminusersrequest';
import {
  IGetAdminUsersResponse,
  ITemporaryPasswordResponse,
} from '../../types/api/response/adminusersresponse';
import { IAdminUser } from '../../types/store';
import axiosClient from '../axiosClient';
import { AdminUsersEndpoints } from '../endpoints/adminUsers';

export const AdminUsersService = {
  async getAdminUsers(params?: IGetAdminUsersRequest): Promise<IGetAdminUsersResponse> {
    const qry = params ? `?page=${params?.page}&size=${params?.size}` : ``;
    const res = await axiosClient.get<IGetAdminUsersResponse>(
      `${AdminUsersEndpoints.RETRIEVE_ADMIN_USERS}${qry}`,
    );
    return res.data;
  },
  async getAdminUser(id: number): Promise<IAdminUser> {
    const res = await axiosClient.get<IAdminUser>(`${AdminUsersEndpoints.GET_ADMIN_USER}?id=${id}`);
    return res.data;
  },
  async createUser(payload: ICreateUserRequest) {
    const res = await axiosClient.post(AdminUsersEndpoints.CREATE_USER, payload);
    return res.data;
  },
  async updateUser(payload: IUpdateUserRequest): Promise<void> {
    await axiosClient.put(AdminUsersEndpoints.UPDATE_ADMIN_USER, payload);
  },
  async deleteUser(payload: IDeleteUserRequest): Promise<void> {
    await axiosClient.delete(AdminUsersEndpoints.DELETE_ADMIN_USER, { data: payload });
  },
  async toggleEnabled(payload: IToggleEnabledRequest): Promise<void> {
    await axiosClient.patch(AdminUsersEndpoints.TOGGLE_ENABLED, payload);
  },
  async resetPassword(payload: IResetPasswordRequest): Promise<void> {
    await axiosClient.post(AdminUsersEndpoints.RESET_PASSWORD, payload);
  },
  async setTemporaryPassword(
    payload: ISetTemporaryPasswordRequest,
  ): Promise<ITemporaryPasswordResponse> {
    const res = await axiosClient.post<ITemporaryPasswordResponse>(
      AdminUsersEndpoints.SET_TEMPORARY_PASSWORD,
      payload,
    );
    return res.data;
  },
};
